module.exports = __webpack_public_path__ + "static/media/last-element-red.a0ce5c48.svg";